import { memo } from 'react';

import { useAtomValue } from 'jotai';

import {
    Data3d,
    activeData3dAtom,
    comparisonData3dAtom,
    activeSwingPlaneAtom,
    comparisonSwingPlaneAtom,
    swingPlanesAtom,
} from '@store';

import { usePlanePositions } from '../hooks/usePlanePositions';
import { Data3D } from '../types';

import { SwingPlane } from './SwingPlane';

type SwingPlanesProps = {
    swing?: 'active' | 'comparison';
};

export const SwingPlanes = ({ swing = 'active' }: SwingPlanesProps) => {
    const data = useAtomValue<Data3d | null>(swing === 'active' ? activeData3dAtom : comparisonData3dAtom);
    const swingPlane = useAtomValue(swing === 'active' ? activeSwingPlaneAtom : comparisonSwingPlaneAtom);
    if (!data) return null;

    return <SwingPlanesWithData {...data} swingPlane={swingPlane} />;
};

const SwingPlanesWithData = ({
    swingPlane,
    clubTrack,
    segmentation,
    skeleton,
    keypointIdToName,
    golfBallTranslation,
}: Pick<
    Data3D,
    'swingPlane' | 'clubTrack' | 'segmentation' | 'skeleton' | 'keypointIdToName' | 'golfBallTranslation'
>) => {
    const planes = useAtomValue(swingPlanesAtom);
    const visualiserPlanes = usePlanePositions({
        swingPlane,
        clubTrack,
        segmentation,
        skeleton,
        keypointIdToName,
        golfBallTranslation,
    });

    if (planes.length === 0) return null;

    return planes.map((plane) => {
        if (!visualiserPlanes[plane]) return null;
        return <SwingPlane key={plane} {...visualiserPlanes[plane]} />;
    });
};

export const MemoSwingPlanes = memo(SwingPlanes);
